import React, { useEffect, useRef, useState } from "react";

function HomeCard({ data, index }) {
  const [isVisible, setIsVisible] = useState(false);
  const [grayscale, setGrayscale] = useState(100);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        // intersectionRatio is a value between 0 and 1
        const ratio = entries[0].intersectionRatio;

        // Calculate grayscale value based on intersection ratio
        const newGrayscale = Math.round((1 - ratio) * 100);

        setGrayscale(newGrayscale);

        if (ratio > 0.1) {
          setIsVisible(true);
        }
      },
      {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] // Trigger callback at these thresholds
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const animationClass = index % 2 === 0 ? "slide-in-right" : "slide-in-left";

  return (
    <div
      ref={cardRef}
      className={`home-card ${isVisible ? animationClass : ""}`}
    >
      <div className="home-card-title">
        {data.name}
      </div>

      <div  style={{ filter: `grayscale(${grayscale}%)` }}>
        <img className="home-card-image"src={data.image} alt={data.name} />
      </div>
      <a className="home-card-link a-card" href={data.link}>{data.link}</a>
      <div className="home-card-description">{data.description}</div>
    </div>
  );
}

export default HomeCard;
